export default {
  costAdjustOrderList: {
    search: {
      companyCode: '公司编码',
      companyName: '公司名称',
      departmentCode: '部门编码',
      departmentName: '部门名称',
      storageDepartmentName: '仓库名称',
      productName: '物料名称',
      batchNo: '业务入库批次号',
      docNo: '单据编号',
      docStatus: '单据状态',
      accountingStatus: '入账状态',
      startGmtCreate: '调整日期 从',
      endGmtCreate: '至',
    },
    column: {
      sortNo: '行号',
      docNo: '单据编号',
      docStatus: '单据状态',
      accountingStatus: '入账状态',
      companyCode: '公司编码',
      companyName: '公司名称',
      departmentCode: '部门编码',
      departmentName: '部门名称',
      storageDepartmentCode: '仓库编码',
      storageDepartmentName: '仓库名称',
      productNo: '物料编码',
      productName: '物料名称',
      batchNo: '业务入库批次号',
      productUnit: '单位',
      gmtCreate: '调整日期',
      storageQuantity: '库存数量',
      storagePrice: '库存单价',
      storageAmount: '库存金额',
      mainBusinessCost: '已发货成本',
      adjustStorageAmount: '业务库存调整金额',
      adjustMainBusinessCost: '已发货成本调整金额',
      currencyName: '币种',
    },
    placeholder: {
      companyCodePlaceholder: '请选择公司',
      departmentCodePlaceholder: '请选择部门',
      productDescPlaceholder: '请选择物品名称',
      storageNamePlaceholder: '请选择仓库名称',
      batchNoPlaceholder: '请输入业务入库批次号',
      docTypePlaceholder: '请选择单据类型',
      docNoPlaceholder: '自动生成',
    },
    btns: {
      add: '创建',
      edit: '编辑',
      save: '保存',
      submit: '提交',
      confirm: '确认',
      doWithdraw: '撤回',
      delete: '删除',
      generateCredentials: '生成凭证',
      writeOff: '冲销',
    },
    msg: {
      editTips: '请选择一条数据修改',
      editTipsError: '当前数据无法修改',
      deleteTips: '请选择需要删除的数据',
    },
  },
};
